//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: 'Compartilhe:'
    },

    socialMedias: {
      type: Array,
      default: () => {
        return ['facebook', 'linkedin', 'whatsapp']
      }
    }
  },

  data() {
    return {
      currentLocation: ''
    }
  },

  computed: {
    translatedTitle() {
      let title = this.title
      title = this.$t('title')

      return title
    }
  },

  mounted() {
    this.getCurrentLocation()
  },

  methods: {
    getCurrentLocation() {
      this.currentLocation = window.location.href
    }
  }
}
